<template>
  <v-app light class="fondo">
     <v-layout row>
        <v-flex xs10 md6 mt-5>
        <v-layout row>
          <v-flex xs10 offset-xs2 md6 mt-5>
             <v-layout column align-center justify-center>
                <img src="../../../static/Logo-blanco-final.png" alt="logo" width="auto" height="80px" class="mt-2">
             </v-layout>
        <form>
          <v-card v-if="codigo" class="mt-3 card-trans" flat  color="white" >
            <v-container grid-list-md class="padding">
    <!--           <v-flex xs12 sm12 class="fondo-primario pt-2 mb-5">
                  <h4 class="text-xs-center white--text pb-2">REGISTRAR</h4>
                </v-flex> -->
              <v-flex xs10 sm10 md10 offset-xs1 class="mt-5 pt-4">
                <p class="body-1 text-xs-center">Por favor, rellene el siguiente formulario</p>
                <v-layout row wrap>
                  <v-flex xs12 sm12>
                    <v-text-field
                      label="Código"
                      class="mt-3 "
                      v-model="usuario.codigo"
                      hint="Ingresa codigo acceso"
                      persistent-hint
                      :rules="[rules.required]"
                      color="blue-grey darken-1 white--text"
                       prepend-icon="lock"
                    ></v-text-field>
                  </v-flex>
                  <p v-if="errorCodigo" class="caption color-error ml-5" >{{ mensajeErrorCodigo }}</p>
                  <v-flex xs12>
                     <v-btn
                        block
                        @click="validarCodigo(usuario)"
                        :disabled="!valid"
                        class="white--text mt-2 minusculas"
                        id="buttons"
                        color="secondary"
                      >
                        Validar
                      </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container >
          </v-card>
          <!-- asdad -->
          <v-card v-if="email" class="mt-3 card-trans" flat  color="white" >
            <v-container grid-list-md class="padding">
                <v-flex xs12 sm12 class="fondo-primario pt-2 mb-3">
                  <h5 class="text-xs-center white--text pb-2">REGISTRAR</h5>
                </v-flex>
              <v-flex xs10 sm10 md10 offset-xs1 >
                <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        label="E-mail"
                        v-model="usuario.email"
                        :rules="[rules.required, rules.email]"
                        hint="Ingresa tu email!"
                        persistent-hint
                        color="blue-grey darken-1 white--text"
                        prepend-icon="email"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                      <v-text-field
                        label="E-mail"
                        v-model="usuario.emailConfirmar"
                        :rules="[rules.required, rules.email]"
                        hint="Confirma tu email!"
                        persistent-hint
                        color="blue-grey darken-1 white--text"
                        prepend-icon="email"
                        ></v-text-field>
                      </v-flex>
                  <p v-if="errorEmail" class="subheadingfont color-error " >{{ mensajeErrorEmail }}</p>
                   <v-flex xs12>
                     <v-btn
                        large
                        block
                        @click="validarEmail(usuario)"
                        :disabled="!valid"
                        class="white--text mt-5"
                        id="buttons"
                      >
                        Siguiente
                      </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container >
          </v-card>
          <!-- asdad -->
          <v-card v-if="datos" class="mt-3 card-trans" flat  color="white" >
            <v-container grid-list-md class="padding">
                 <v-flex xs12 sm12 class="fondo-primario pt-2">
                  <h5 class="text-xs-center white--text pb-2">REGISTRAR</h5>
                </v-flex>
              <v-flex xs10 sm10 md10 offset-xs1 >
                <v-layout row wrap>
                    <v-flex xs12 sm12>
                      <v-text-field prepend-icon="person" persistent-hint  color="blue-grey darken-1 white--text" label="Nombre" hint="Ingresa tu nombre" :rules="[rules.required]" v-model="usuario.nombre"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12>
                      <v-text-field  label="Apellido" persistent-hint color="blue-grey darken-1 white--text" prepend-icon="group" hint="Ingresa tu apellido" :rules="[rules.required]" v-model="usuario.apellido"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12>
                      <v-text-field
                        v-mask="rut"
                        label="Rut"
                        v-model="usuario.rut"
                        hint="Ingresa tu rut"
                        persistent-hint
                        :rules="[rules.required]"
                        color="blue-grey darken-1 white--text"
                        prepend-icon="account_box"
                      ></v-text-field>
                    </v-flex>
                   <v-flex xs12>
                     <v-btn
                     large
                        block
                        @click="validarDatos(usuario)"
                        :disabled="!valid"
                        class="white--text"
                        id="buttons"
                      >
                        Siguiente
                      </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container >
          </v-card>
           <!-- asdad -->
          <v-card v-if="contraseña" class="mt-3 card-trans" flat  color="white" >
            <v-container grid-list-md class="padding">
                <v-flex xs12 sm12 class="fondo-primario pt-2 mb-5">
                  <h4 class="text-xs-center white--text mb-2">REGISTRAR</h4>
                </v-flex>
              <v-flex xs10 sm10 md10 offset-xs1 >
                <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          name="input-10-1"
                          label="Crea tu contraseña"
                          hint="Minimo 8 caracteres"
                          v-model="usuario.password"
                          min="8"
                          :rules="[rules.required]"
                          :append-icon="e1 ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (e1 = !e1)"
                          :type="e1 ? 'password' : 'text'"
                          color="blue-grey darken-1 white--text"
                          counter
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          name="input-10-1"
                          label="Confirma tu contraseña"
                          hint="Recuerda ingresar nuevamente tu clave."
                          v-model="usuario.passwordConfirm"
                          min="8"
                          :rules="[rules.required]"
                          :append-icon="e1 ? 'visibility' : 'visibility_off'"
                          :append-icon-cb="() => (e1 = !e1)"
                          :type="e1 ? 'password' : 'text'"
                          color="blue-grey darken-1 white--text"
                          counter
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs2>
                            <v-checkbox
                            v-model="ex4"
                            color="orange darken-3"
                            class="mt-2"
                            hide-details></v-checkbox>
                          </v-flex>
                          <v-flex xs10>
                            <v-btn color="orange darken-3" flat="flat" @click="dialog = true">Acepto términos y acuerdos</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <p v-if="errorContraseñaCondiciones" class="subheadingfont color-error " >{{ mensajeErrorContraseñaCondiciones }}</p>
                   <v-flex xs12>
                     <v-btn
                     large
                        block
                        @click="submitUser(usuario)"
                        :disabled="!valid"
                        class=" white--text"
                        id="buttons"
                      >
                        Crea tu cuenta
                      </v-btn>
                      <v-btn  class="mb-4  minusculas secondary--text" block  @click="goRegister()">Iniciar Sesión</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container >
          </v-card>
          <v-card v-if="codigo" class="mt-3 card-trans" flat  color="white" >
            <v-container grid-list-md class="padding">
              <v-flex xs10 sm10 md10 offset-xs1 class="mt-2 pt-2 pb-1">
                <p class="body-1 text-xs-center">¿ya tienes una cuenta?</p>
                     <v-btn  class="mb-2  minusculas secondary--text" block  @click="goLogin()">Inicia Sesión</v-btn>
              </v-flex>
            </v-container>
          </v-card>
        </form>
      </v-flex>
    </v-layout>
      </v-flex>
    </v-layout>
      <v-snackbar
              :timeout="timeout"
              :color="color"
              :multi-line="mode === 'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbar"
      >
          {{ text }}
          <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
      </v-snackbar>

    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline center-text">Terminos y Condiciones</span>
        </v-card-title>
        <v-card-text>
          El presente acuerdo de Política de Privacidad establece los términos en que Acamy usa y protege la información que es proporcionada por sus usuarios al momento de utilizar su sitio web. Esta compañía está comprometida con la seguridad de los datos de sus usuarios. Cuando le pedimos llenar los campos de información personal con la cual usted pueda ser identificado, lo hacemos asegurando que sólo se empleará de acuerdo con los términos de este documento. Sin embargo, esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios.
          Información que es recogida
          Nuestro sitio web podrá recoger información personal, por ejemplo: Nombre, información de contacto como su dirección de correo electrónica e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica para alguna nueva funcionalidad.
          <br>
          <strong>Uso de la información recogida</strong>
          <br>
          Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios, y mejorar nuestros productos y servicios.  Es posible que sean enviados correos electrónicos periódicamente a través de nuestro sitio con información que consideremos relevante para usted o que pueda brindarle algún beneficio, estos correos electrónicos serán enviados a la dirección que usted proporcione.
          Acamy está altamente comprometido para cumplir con el compromiso de mantener su información segura. Usamos los sistemas más avanzados y los actualizamos constantemente para asegurarnos que no exista ningún acceso no autorizado.
          <br>
          <strong>Cookies</strong>
          <br>
          Una cookie se refiere a un fichero que es enviado con la finalidad de solicitar permiso para almacenarse en su ordenador, al aceptar dicho fichero se crea y la cookie sirve entonces para tener información respecto al tráfico web, y también facilita las futuras visitas a una web recurrente. Otra función que tienen las cookies es que con ellas las web pueden reconocerte individualmente y por tanto brindarte el mejor servicio personalizado de su web.
          Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su frecuencia. Esta información es empleada únicamente para análisis estadístico y después la información se elimina de forma permanente. Usted puede eliminar las cookies en cualquier momento desde su ordenador. Sin embargo las cookies ayudan a proporcionar un mejor servicio de los sitios web, estás no dan acceso a información de su ordenador ni de usted, a menos de que usted así lo quiera y la proporcione directamente. Usted puede aceptar o negar el uso de cookies, sin embargo la mayoría de navegadores aceptan cookies automáticamente pues sirve para tener un mejor servicio web. También usted puede cambiar la configuración de su ordenador para declinar las cookies. Si se declinan es posible que no pueda utilizar algunos de nuestros servicios.
          <br>
          <strong>Enlaces a Terceros</strong>
          <br>
          Este sitio web pudiera contener en laces a otros sitios que pudieran ser de su interés. Una vez que usted de clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al que es redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está de acuerdo con estas.
          Control de su información personal
          En cualquier momento usted puede restringir la recopilación o el uso de la información personal que es proporcionada a nuestro sitio web.
          Esta compañía no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, salvo que sea requerido por un juez con un orden judicial.
          Acamy se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>


</template>

<script>
import { userRecorderService } from '@/services/UserRecorder.service'
import { validCodeService } from '@/services/ValidCode.service'
export default {
  data () {
    return {
      e1: false,
      dialog: false,
      valid: true,
      codigo: true,
      contraseña: false,
      datos: false,
      email: false,
      errorCodigo: false,
      snackbar: false,
      color: 'red',
      mode: 'vertical',
      timeout: 6000,
      text: '',
      errorEmail: false,
      errorContraseñaCondiciones: false,
      mensajeErrorCodigo: '',
      mensajeErrorEmail: '',
      mensajeErrorContraseñaCondiciones: '',
      usuario: {},
      ex4: false,
      rules: {
        required: (value) => !!value || 'Requerido.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Email incorrecto.'
        },
        min5: (value) => {
          const pattern = / /
          return pattern.test(value || 'Minimo 5 caracteres')
        }
      },
      rut: {
        mask: ['#.###.###-K', '##.###.###-K'],
        tokens: {
          '#': {
            pattern: /\d/
          },
          'K': {
            pattern: /[0-9-k-k-K-K]/,
            transform: v => v.toLocaleUpperCase()
          }
        }
      }
    }
  },
  methods: {
    submitUser (model) {
      if (this.ex4 && (model.password === model.passwordConfirm) && (model.password).length > 4) {
        userRecorderService.save(model).then(data => {
          this.usuario = {}
          this.codigo = true
          this.contraseña = false
          this.color = 'success'
          this.text = 'Registro Exitoso'
          this.snackbar = true
        }, response => {
          this.usuario = {}
          this.codigo = true
          this.contraseña = false
          this.color = 'error'
          this.text = response.data
          this.snackbar = true
        })
      } else {
        if (!this.ex4) {
          this.mensajeErrorContraseñaCondiciones = 'Debes haceptar la condiciones'
        } else {
          this.mensajeErrorContraseñaCondiciones = 'Contraseñas diferentes'
        }
        if ((model.password).length < 5) {
          this.mensajeErrorContraseñaCondiciones = 'La contraseña debe tener minimo 5 caracteres'
        }
        this.errorContraseñaCondiciones = true
      }
    },
    validarCodigo (model) {
      validCodeService.save(model).then(data => {
        this.codigo = false
        this.email = true
      }, response => {
        this.errorCodigo = true
        this.mensajeErrorCodigo = response.body
      })
    },
    validarEmail (model) {
      if (model.email === model.emailConfirmar) {
        this.email = false
        this.datos = true
      } else {
        this.errorEmail = true
        this.mensajeErrorEmail = 'Emails diferentes'
      }
    },
    validarDatos (model) {
      this.datos = false
      this.contraseña = true
    },
    clear () {
      this.$refs.form.reset()
    },
    goLogin () {
      this.$router.push('/auth/login')
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

.card-trans{
  background-color: #ffffff80 !important;
  border: #ffffff80 !important;
  height: 40%;
}

.fondo{
  background-image: url('../../../static/Capa8.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100% ;
}

#buttons{
  background-color: #EB6330;
}

.fondo-primario{
  background-color: #EB6330;
}

.padding{
  padding: 0px!important;
}

.color-error{
  color: #ff5252;
}

  .minusculas {
  text-transform: capitalize
}
</style>




// WEBPACK FOOTER //
// src/components/Usuario/NewUsuario.vue